import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { YoutubeCodeScrapperPipe } from 'src/app/pipes/youtube-code-scrapper/youtube-code-scrapper.pipe';
import { CompanyCompanyService } from 'src/app/services/company-services/company-company-service/company-company.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { MediaGalleryAddHtmlDialogComponent } from '../media-gallery-add-html-dialog/media-gallery-add-html-dialog.component';
import { MediaGalleryAddImageDialogComponent } from '../media-gallery-add-image-dialog/media-gallery-add-image-dialog.component';
import { MediaGalleryAddVideoDialogComponent } from '../media-gallery-add-video-dialog/media-gallery-add-video-dialog.component';
import { MediaGalleryZoomDialogComponent } from '../media-gallery-zoom-dialog/media-gallery-zoom-dialog.component';
import { MediaGalleryItem } from './media-gallery-item.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-media-gallery-item',
  templateUrl: './media-gallery-item.component.html',
  styleUrls: ['./media-gallery-item.component.scss']
})
export class MediaGalleryItemComponent implements OnInit, OnChanges {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() item: MediaGalleryItem;
  @Input() size;
  @Output() updateItem = new EventEmitter();
  @Output() removeItem = new EventEmitter();
  @Output() itemSelectedOutputEvent = new EventEmitter();
  showSpinner: boolean;
  showItemInfoFlag: boolean;
  webscript;
  weburl;

  constructor(private validationImageService: ValidationImageService,
              private snackbarService: SnackBarService,
              private sanitizer: DomSanitizer,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
    this.showItemInfoFlag = false;
  }

  ngOnChanges() {
    if (this.item) {
      switch (this.item.Type) {
        case 'WEB_SCRIPT':
          this.sanitizeWebscript(this.item.Content);
        break;
        case 'WEB_URL':
          this.sanitizeWeburl(this.item.Content);
        break;
      }
    }
  }

  public saveAsset(asset) {
    this.updateItem.emit({ currentItem: this.item, item: asset});
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const image = new MediaGalleryItem(null, this.uploadInput.nativeElement.files[0].name, 'IMAGE_FILE', base64, base64, false, null, 60, null, null);
        this.item = image;
      },
      (error) => {
        this.snackbarService.open(error, 'error');
      }
    );
  }

  private sanitizeWebscript(webscript) {
    this.webscript = this.sanitizer.bypassSecurityTrustHtml(webscript);
  }
  private sanitizeWeburl(weburl) {
    this.weburl = this.sanitizer.bypassSecurityTrustResourceUrl(weburl);
  }

  public deleteAsset() {
    this.removeItem.emit(this.item);
  }

  public updateAsset() {
    switch (this.item.Type) {
      case 'IMAGE_FILE':
        this.updateImage();
        break;
      case 'IMAGE_URL':
        this.updateImage();
        break;
      case 'VIDEO_FILE':
        this.updateVideo();
        break;
      case 'VIDEO_URL':
        this.updateVideo();
        break;
      case 'VIDEO_YOUTUBE':
        this.updateVideo();
        break;
      case 'WEB_URL':
        this.updateWeb();
        break;
      case 'WEB_SCRIPT':
        this.updateWeb();
        break;
    }
  }

  public updateImage() {
    const dialogRef = this.dialog.open(MediaGalleryAddImageDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result.length === 1)) {
        this.updateItem.emit({ currentItem: this.item, item: result[0]});
      } else if (result && (result.length > 1)) {
        this.snackbarService.open('Select only one file', 'error');
      }
    });
  }

  public updateVideo() {
    const dialogRef = this.dialog.open(MediaGalleryAddVideoDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result.length === 1)) {
        this.updateItem.emit({ currentItem: this.item, item: result[0]});
      } else if (result && (result.length > 1)) {
        this.snackbarService.open('Select only one file', 'error');
      }
    });
  }

  public updateWeb() {
    const dialogRef = this.dialog.open(MediaGalleryAddHtmlDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result.length === 1)) {
        this.updateItem.emit({ currentItem: this.item, item: result[0]});
      }
    });
  }

  public itemSelected() {
    this.itemSelectedOutputEvent.emit();
  }

  public getPlaceholder() {
    switch (this.item.Type) {
      case 'IMAGE_FILE':
        return 'assets/images/placeholder_nophoto.png';
      case 'IMAGE_URL':
        return 'assets/images/placeholder_nophoto.png';
      case 'VIDEO_FILE':
        return 'assets/images/placeholder_novideo.png';
      case 'VIDEO_URL':
        return 'assets/images/placeholder_novideo.png';
      case 'VIDEO_YOUTUBE':
        return 'assets/images/placeholder_novideo.png';
      case 'WEB_URL':
        return 'assets/images/placeholder_noweburl.png';
      case 'WEB_SCRIPT':
        return 'assets/images/placeholder_nowebscript.png';
    }
  }

  public zoom() {
    const dialogRef = this.dialog.open(MediaGalleryZoomDialogComponent, { data: this.item });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        switch (res['action']) {
          case 'save':
            this.saveAsset(res['data']);
          break;
          case 'update':
            this.updateAsset();
          break;
          case 'delete':
            this.deleteAsset();
          break;
        }
      }
    });
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public getTypeIcon() {
    switch (this.item.Type) {
      case 'IMAGE_FILE':
        return 'fas fa-file-image';
      case 'IMAGE_URL':
        return 'fas fa-image';
      case 'VIDEO_FILE':
        return 'fas fa-video';
      case 'VIDEO_URL':
        return 'fas fa-video';
      case 'VIDEO_YOUTUBE':
        return 'fab fa-youtube';
      case 'WEB_SCRIPT':
        return 'fas fa-laptop-code';
      case 'WEB_URL':
        return 'fas fa-link';
    }
  }

  public showItemInfo() {
    this.showItemInfoFlag = true;
  }

  public hideItemInfo() {
    this.showItemInfoFlag = false;
  }

  public getWidth(eRef) {
    return eRef.offsetWidth;
  }
}
